export default __webpack_public_path__ + "static/media/is_this_you_m.6ce98147.jpg";